import { I18N } from "./I18N.js"
import logoUrl from "./img/Lieferservice-Logo_gruen_trans.png"

export class Menu {
	_target
	_appContext

	constructor(target, appContext) {
		this._appContext = appContext
		this._target = document.getElementById(target)
		this._target.innerHTML = `
			<ul>
				<li id="headerBranding"><div class="logo"><img src="${logoUrl}" alt="VLS logo"></div><div class="label">Viertel-Lieferservice Bestellungen</div></li>
				<li><a id="aboutUsMenuItem" href="aboutUs" i18n>About Us</a></li>
				<li><a id="counterMenuItem" href="counter" i18n>Counter</a></li>
			</ul>
			<ul>
				<li><a id="keycloakAccountMenuItem" href="keycloakAccount"><span class="material-icons-outlined">account_circle</span></a></li>
				<li><a id="userInfoMenuItem" href="userInfo"><span class="material-icons-outlined">info</span></a></li>
				<li><a id="logoutMenuItem" href="logout"><span class="material-icons-outlined">logout</span></a></li>
				<li><a id="loginMenuItem" href="login"><span class="material-icons-outlined">login</span></a></li>
			</ul>`
		this._target.querySelectorAll('a').forEach(a => {
			if (this._appContext.isActive(a.getAttribute('href'))) {
				a.setAttribute('active', '')
			}
			if (!this._appContext.isOpen(a.getAttribute('href'))) {
				a.setAttribute('disabled', '')
			}
			a.addEventListener('click', ev => {
				ev.preventDefault()
				this._target.querySelectorAll('a').forEach(a => a.removeAttribute('active'))
				ev.currentTarget.setAttribute('active', '')
				this._appContext.setActive(ev.currentTarget.getAttribute('href'))
				return null
			})
		})
		I18N.translateElement(this._target)
	}

	/**
	 * Called by context to show or hide menu entry.
	 * 
	 * @param {*} activity 
	 * @param {*} open 
	 */
	setOpen = (activity, open) => this._target.querySelectorAll(`a[href=${activity}]`).forEach(a => open ? a.removeAttribute('disabled') : a.setAttribute('disabled', ''))

	/**
	 * Called by context to set menu entry active.
	 * 
	 * @param {*} activity 
	 */
	setActive = activity => {
		this.setOpen(activity, true)
		this._target.querySelectorAll('a').forEach(a => a.removeAttribute('active'))
		this._target.querySelector(`a[href=${activity}]`).setAttribute('active', '')
	}

}